export default __webpack_public_path__ + "static/media/arrow_down_accordion.50817db8.svg";